"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeCategoriesClient = void 0;
class FakeCategoriesClient {
    constructor() {
        this.categories = {};
    }
    getCategories() {
        return Promise.resolve(this.categories);
    }
    clear() {
        this.categories = {};
    }
    insertCategory(categories) {
        if (categories) {
            for (const [k, v] of Object.entries(categories)) {
                this.categories[k] = v;
            }
        }
    }
}
exports.FakeCategoriesClient = FakeCategoriesClient;
//# sourceMappingURL=FakeCategoriesClient.js.map